module.exports = __webpack_public_path__ + "static/media/login.2ce35a68.png";